/* ----------------- Third parties --------------- */
import { Dialog } from "react-native-paper";

import { events } from "@constants/tracking";
/* ----------------- UI --------------- */
import useAnalytics from "@hooks/useAnalytics";
import { useAppTheme } from "@hooks/useAppTheme";
import DialogWrapper from "@memorang/ui/src/components/DialogWrapper";
import { ToastProvider } from "@memorang/ui/src/components/Toast";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
/* ----------------- Components --------------- */
import DeleteForm from "../DeleteForm";

type Props = {
	visible: boolean;
	handleDismiss: () => void;
	handleSendFeedback: () => void;
};
const DeleteConfirmationDialog = ({
	visible,
	handleDismiss,
	handleSendFeedback,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const { explicitCallTrackCustomEvent } = useAnalytics();

	useEffect(() => {
		if (visible) {
			explicitCallTrackCustomEvent({
				eventName: events.dialogOpened,
				type: "delete_confirmation",
			});
		}
	}, [visible, explicitCallTrackCustomEvent]);

	const handleDialogClose = () => {
		handleDismiss();
		explicitCallTrackCustomEvent({
			eventName: events.dialogClosed,
			type: "delete_confirmation",
		});
	};
	return (
		<DialogWrapper
			visible={visible}
			maxWidth={"xs"}
			handleClose={handleDialogClose}
		>
			<Dialog.Icon color={theme.colors.error} icon="alert-outline" />
			<Dialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{t("dialog.delete.confirmdelete.title")}
			</Dialog.Title>
			<Dialog.Content>
				<ToastProvider>
					<DeleteForm
						handleDismiss={handleDialogClose}
						handleSendFeedback={handleSendFeedback}
					/>
				</ToastProvider>
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default DeleteConfirmationDialog;
